import { render, staticRenderFns } from "./foot.vue?vue&type=template&id=4233965f&scoped=true&"
import script from "./foot.vue?vue&type=script&lang=js&"
export * from "./foot.vue?vue&type=script&lang=js&"
import style0 from "./foot.vue?vue&type=style&index=0&id=4233965f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4233965f",
  null
  
)

export default component.exports